export default {"src":"/_next/static/media/gooseberries.16457d8f.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};